import { combineReducers } from 'redux';
import imgCate from '../redux/imgCate/imgCateReducer';
import { reducer as form } from 'redux-form';
import dialogIframe from '../redux/dialogIframe/dialogIframeReducer';
import projApollo from '../redux/projApollo/reducer';
import actConfDialog from '../redux/actConfDialog/reducer';
import bb from '../redux/boundingBox/reducer';
import demeter from '../redux/demeter/reducer';
import imgSegment from '../redux/imgSegment/reducer';
import gorgon from '../redux/gorgon/reducer'
import kratosec from '../redux/kratosec/reducer'
import hermes from '../redux/hermes/reducer'
import eros from '../redux/eros/reducer'
import leto from '../redux/leto/reducer'
import phobos from '../redux/phobos/reducer'
import deimos from '../redux/deimos/reducer'
import harmonia from '../redux/harmonia/reducer'
import morpheus from '../redux/morpheus/reducer'
import nemesis from '../redux/nemesis/reducer'
import orion from '../redux/orion/reducer'
import rhea from '../redux/rhea/reducer'
import uranus from '../redux/uranus/reducer'
import theia from '../redux/theia/reducer'
import selene from '../redux/selene/reducer'
import kratos from '../redux/kratos/reducer'
import athena from '../redux/athena/reducer'
import generic from '@lesofi/phoenix-sdk-js/lib/genericReducer/reducer'

export default combineReducers(
    {form,imgCate,dialogIframe,projApollo,actConfDialog,bb,demeter,imgSegment,gorgon,kratosec,hermes,eros,leto,phobos,deimos,harmonia,morpheus,nemesis,orion,rhea,uranus,theia,selene,kratos,generic,athena}
    );


// WEBPACK FOOTER //
// ./src/redux/reducer.js